import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
// import { setMenuActive } from "../../actions/menuAction";
import { switchMode } from "../../actions/modeAction";
import { openSettings } from "../../actions/settingActions";
import SettingPopup from "../SettingPopup";
import "./ProfileCard.css";

const ProfilePage = () => {
  const profileDropdown = useRef(null);
  const element = useRef(null);
  const [showHeader, setShowHeader] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [profileDropdownShow, setProfileDropdownShow] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { mode } = useSelector((state) => state.mode);
  const { isSettingOpen } = useSelector((state) => state.setting);
  const teacherMode =
    mode === "teacher" || mode === "learning" || mode === "teaching";
  const showDropdown = (e) => {
    profileDropdown.current.classList.toggle("show");
    setProfileDropdownShow(true);
    setShowHeader(true);
    setShowSidebar(true);
  };

  const handleSwitchMode = () => {
    mode === "teacher"
      ? dispatch(switchMode("learning"))
      : mode === "learning"
      ? dispatch(switchMode("teaching"))
      : mode === "teaching"
      ? dispatch(switchMode("learning"))
      : dispatch(switchMode("teacher"));

    // profileDropdown.current.classList.remove("show");
  };

  const showSetting = (e) => {
    if (profileDropdown.current.classList.contains("show")) {
      profileDropdown.current.classList.remove("show");
    }
    if (e.target !== e.currentTarget) return;
    if (isSettingOpen) {
      dispatch(openSettings(false));
    } else {
      console.log("hai");
      dispatch(openSettings(true));
    }
  };

  // const handleProfile = () => {
  //   history.push("/profile");
  //   dispatch(setMenuActive("profile"));
  //   if (profileDropdown.current.classList.contains("show")) {
  //     profileDropdown.current.classList.remove("show");
  //   }
  // };

  const handleRefer = () => {
    history.push("/refer");
    if (profileDropdown.current.classList.contains("show")) {
      profileDropdown.current.classList.remove("show");
    }
  };

  useEffect(() => {
    window.onclick = (e) => {
      if (profileDropdownShow) {
        if (e.target.closest("#profile-dropdown") === null) {
          profileDropdown.current.classList.remove("show");
          setProfileDropdownShow(false);
        }
      }
    };

    const body = document.getElementsByTagName("body")[0];
    if (darkMode) {
      body.classList.add("dark-mode");
    } else {
      body.classList.remove("dark-mode");
    }
  }, [darkMode, showHeader, showSidebar, profileDropdownShow]);

  return (
    <>
      <div className={`profileCard header`} onClick={showDropdown}>
        <div className={`profileCard__profileLeft header`}>
          <div className="profileCard__profileImg">
            <img
              src="https://images.unsplash.com/photo-1554126807-6b10f6f6692a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=870&q=80"
              alt="profilepicture"
              className="rounded"
            />
          </div>
          <div className={`profileCard__profileText header`}>
            <h3>Abraham Benjamin </h3>
            <div className="flex-row">
              <p>{teacherMode ? "Teacher" : "Radiant"}</p>
              {!teacherMode && (
                <img
                  src="https://gist.githubusercontent.com/geniusparkle-team/4c2f877f0ee16ad6d3b68d42fc904621/raw/a1dbf42e50373bcf58bd67c60f6653f21b0effff/radiant.svg"
                  alt="radiant"
                  className="profileCard__badge"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`profileCard__dropdow flex-column  header`}
        ref={profileDropdown}
        id="profile-dropdown"
      >
        <div
          className="profileCard__dropdownHeader flex-row"
          // onClick={handleProfile}
        >
          <div className="profileCard__dropdownProfileImg flex-column">
            <img
              src="https://images.unsplash.com/photo-1554126807-6b10f6f6692a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=870&q=80"
              alt="profilepicture"
              className="rounded profileCard__dropdownProfiePicture"
            />
            <div className="profileCard__dropdownProfileText flex-column">
              <h3>
                Abraham Benjamin{" "}
                {mode === "teacher" && (
                  <svg
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.45898 13L11.7292 18.2708L22 8"
                      stroke="#077aff"
                      strokeWidth="3.54167"
                      strokeLinecap="round"
                    />
                  </svg>
                )}
              </h3>
              <div className="flex-row">
                {!teacherMode && (
                  <img
                    src="https://gist.githubusercontent.com/geniusparkle-team/4c2f877f0ee16ad6d3b68d42fc904621/raw/a1dbf42e50373bcf58bd67c60f6653f21b0effff/radiant.svg"
                    alt="radiant"
                    className="profileCard__badge"
                  />
                )}
                <p>{teacherMode ? "Teacher" : "Radiant"}</p>
              </div>
            </div>
          </div>
          <div className="profileCard__dropdowProfileDetails">
            <div className="profileCard__dropdowProfileDetail">
              <small>{teacherMode ? "Sessions" : "Projects"}</small>
              <p>0</p>
            </div>
            <div className="profileCard__dropdowProfileDetail">
              <small>Balance</small>
              <p>$0.00</p>
            </div>
            <div className="profileCard__dropdowProfileDetail status">
              <small>{teacherMode ? "Topic" : "My Plan"}</small>
              <p>{teacherMode ? "Science" : "Free"}</p>
            </div>
          </div>
        </div>
        <ul className="profileCard__dropdownMenu flex-column" ref={element}>
          <li
            className="profileCard__dropdownMenuItem flex-row"
            onClick={handleRefer}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 7H18C18.6566 7 19.3068 7.12933 19.9134 7.3806C20.52 7.63188 21.0712 8.00017 21.5355 8.46447C21.9998 8.92876 22.3681 9.47996 22.6194 10.0866C22.8707 10.6932 23 11.3434 23 12C23 12.6566 22.8707 13.3068 22.6194 13.9134C22.3681 14.52 21.9998 15.0712 21.5355 15.5355C21.0712 15.9998 20.52 16.3681 19.9134 16.6194C19.3068 16.8707 18.6566 17 18 17H15M9 17H6C5.34339 17 4.69321 16.8707 4.08658 16.6194C3.47995 16.3681 2.92876 15.9998 2.46447 15.5355C1.52678 14.5979 1 13.3261 1 12C1 10.6739 1.52678 9.40215 2.46447 8.46447C3.40215 7.52678 4.67392 7 6 7H9"
                stroke="#0F0F0F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 12H16"
                stroke="#0F0F0F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            {mode === "teacher" || mode === "learning" || mode === "teaching"
              ? "Refer Students"
              : "Refer Your Friends"}
          </li>
          {!teacherMode && (
            <li
              className="profileCard__dropdownMenuItem flex-row membership"
              onClick={() =>
                (window.location.href =
                  "https://geniusparkle.com/pricing?upgrade")
              }
            >
              <svg
                width="49"
                height="49"
                viewBox="0 0 49 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M36.0077 28.7543C35.4897 29.2563 35.2517 29.9823 35.3697 30.6943L37.1477 40.5343C37.2977 41.3683 36.9457 42.2123 36.2477 42.6943C35.5637 43.1943 34.6537 43.2543 33.9077 42.8543L25.0497 38.2343C24.7417 38.0703 24.3997 37.9823 24.0497 37.9723H23.5077C23.3197 38.0003 23.1357 38.0603 22.9677 38.1523L14.1077 42.7943C13.6697 43.0143 13.1737 43.0923 12.6877 43.0143C11.5037 42.7903 10.7137 41.6623 10.9077 40.4723L12.6877 30.6323C12.8057 29.9143 12.5677 29.1843 12.0497 28.6743L4.82767 21.6743C4.22367 21.0883 4.01367 20.2083 4.28967 19.4143C4.55767 18.6223 5.24167 18.0443 6.06767 17.9143L16.0077 16.4723C16.7637 16.3943 17.4277 15.9343 17.7677 15.2543L22.1477 6.27426C22.2517 6.07426 22.3857 5.89026 22.5477 5.73426L22.7277 5.59426C22.8217 5.49026 22.9297 5.40426 23.0497 5.33426L23.2677 5.25426L23.6077 5.11426H24.4497C25.2017 5.19226 25.8637 5.64226 26.2097 6.31426L30.6477 15.2543C30.9677 15.9083 31.5897 16.3623 32.3077 16.4723L42.2477 17.9143C43.0877 18.0343 43.7897 18.6143 44.0677 19.4143C44.3297 20.2163 44.1037 21.0963 43.4877 21.6743L36.0077 28.7543Z"
                  fill="white"
                />
              </svg>
              Upgrade Membership
            </li>
          )}

          {teacherMode && (
            <li className="profileCard__dropdownMenuItem flex-row withdrawal-option">
              <svg
                viewBox="0 0 512 512"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M104.044 221.204H91.8144C81.4235 221.204 73 212.78 73 202.389V52.8144C73 42.4235 81.4235 34 91.8144 34H419.186C429.577 34 438 42.4235 438 52.8144V202.389C438 212.78 429.576 221.204 419.186 221.204H418.245"
                  stroke="black"
                  strokeWidth="47.0361"
                  strokeLinecap="square"
                  strokeLinejoin="round"
                />
                <path
                  d="M157.809 81.0373C144.225 81.0373 133.213 92.0494 133.213 105.633L133.213 279.643V286.033L133.216 487.291C133.216 500.875 144.228 511.887 157.812 511.887L361.271 511.887C374.855 511.887 385.867 500.875 385.867 487.291L385.867 105.632C385.867 92.0483 374.855 81.0362 361.271 81.0363L157.809 81.0373ZM304.377 124.809C307.559 124.809 310.14 127.389 310.14 130.572C310.14 145.69 322.37 157.989 337.404 157.989C340.587 157.989 343.167 160.569 343.167 163.752L343.167 429.174C343.167 432.356 340.587 434.936 337.404 434.936C322.37 434.936 310.14 447.236 310.14 462.354C310.14 465.537 307.559 468.117 304.377 468.117L216.323 468.117C213.14 468.117 210.56 465.538 210.56 462.354C210.56 447.236 198.332 434.936 183.301 434.936C180.118 434.936 177.538 432.356 177.538 429.174L177.538 163.752C177.538 160.569 180.118 157.989 183.301 157.989C198.332 157.989 210.56 145.69 210.56 130.572C210.56 127.389 213.139 124.809 216.323 124.809L304.377 124.809Z"
                  fill="black"
                />
                <path
                  d="M231.045 297.71C231.045 313.274 243.638 325.936 259.116 325.936C274.591 325.936 287.179 313.274 287.179 297.71C287.179 282.147 274.591 269.482 259.116 269.482C243.638 269.482 231.045 282.145 231.045 297.71Z"
                  fill="black"
                />
                <path
                  d="M198.76 167.343C193.215 169.853 188.636 174.835 188.636 180.922L188.636 414.499C188.636 420.585 193.215 425.567 198.76 428.077C207.407 431.992 214.378 438.999 218.268 447.687C220.759 453.249 225.746 457.838 231.841 457.838L288.002 457.838C294.096 457.838 299.083 453.249 301.574 447.687C305.465 438.999 312.439 431.99 321.089 428.076C326.634 425.566 331.214 420.584 331.214 414.497L331.214 180.921C331.214 174.835 326.635 169.853 321.089 167.343C312.44 163.429 305.465 156.421 301.574 147.733C299.083 142.17 294.096 137.581 288.002 137.581L231.841 137.581C225.746 137.581 220.759 142.17 218.269 147.733C214.379 156.42 207.407 163.428 198.76 167.343ZM298.704 297.71C298.704 319.629 280.944 337.461 259.116 337.461C237.283 337.461 219.52 319.629 219.52 297.71C219.52 275.791 237.283 257.959 259.116 257.959C280.944 257.957 298.704 275.79 298.704 297.71Z"
                  fill="black"
                />
              </svg>
              Withdrawal
            </li>
          )}

          <li
            className="profileCard__dropdownMenuItem flex-row"
            onClick={handleSwitchMode}
          >
            {mode === "teacher" ? (
              <>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.54618 3.27793C7.71236 3.39789 7.98037 3.67345 7.98037 3.67345C9.02079 4.64858 10.5879 7.07394 11.0911 8.30444C11.1016 8.30444 11.4001 9.03608 11.4118 9.38409V9.43041C11.4118 9.96371 11.1133 10.4626 10.6335 10.7179C10.4357 10.8232 9.95456 10.9211 9.72244 10.9683C9.64556 10.984 9.59599 10.9941 9.59308 10.997C8.90727 11.1016 7.85514 11.1704 6.70003 11.1704C5.48757 11.1704 4.38981 11.1016 3.71453 10.9733C3.70282 10.9733 3.08606 10.8462 2.88009 10.7642C2.58282 10.6372 2.3312 10.4044 2.17087 10.1145C2.05618 9.88294 2 9.63827 2 9.38409C2.01053 9.11685 2.18257 8.618 2.26215 8.42083C2.76539 7.12026 4.41204 4.6367 5.41852 3.68532C5.52307 3.57922 5.64206 3.46806 5.72485 3.39071C5.76902 3.34945 5.8029 3.3178 5.81877 3.30169C6.07039 3.10452 6.37936 3 6.71173 3C7.00783 3 7.30509 3.09264 7.54618 3.27793ZM18.2286 10.1618C18.2286 10.6856 17.8108 11.1096 17.2947 11.1096C16.7786 11.1096 16.3608 10.6856 16.3608 10.1618L16.1033 5.58295C16.1033 4.91543 16.637 4.375 17.2947 4.375C17.9524 4.375 18.4849 4.91543 18.4849 5.58295L18.2286 10.1618ZM21.1199 13.2356C21.4172 13.3639 21.6688 13.5955 21.8291 13.8853C21.9438 14.1169 22 14.3616 22 14.617C21.9895 14.883 21.8174 15.3831 21.7367 15.5802C21.2346 16.8797 19.5868 19.3633 18.5815 20.3158C18.4787 20.4194 18.3619 20.5284 18.2793 20.6055H18.2792C18.2331 20.6486 18.1976 20.6817 18.1812 20.6983C17.9284 20.8955 17.6206 21 17.2894 21C16.991 21 16.6937 20.9074 16.4538 20.7209C16.2876 20.6021 16.0196 20.3265 16.0196 20.3265C14.978 19.3526 13.4121 16.926 12.9089 15.6954C12.8972 15.6954 12.5999 14.965 12.5882 14.617V14.5706C12.5882 14.0361 12.8855 13.5373 13.3665 13.2819C13.5639 13.1777 14.0435 13.0796 14.2762 13.0319C14.3539 13.016 14.404 13.0058 14.4069 13.0028C15.0927 12.8983 16.1449 12.8294 17.3 12.8294C18.5124 12.8294 19.6102 12.8983 20.2855 13.0265C20.296 13.0265 20.9139 13.1536 21.1199 13.2356ZM6.70553 12.8905C6.18942 12.8905 5.77161 13.3146 5.77161 13.8383L5.51414 18.4171C5.51414 19.0846 6.04781 19.625 6.70553 19.625C7.36325 19.625 7.89575 19.0846 7.89575 18.4171L7.63945 13.8383C7.63945 13.3146 7.22165 12.8905 6.70553 12.8905Z"
                    fill="black"
                  />
                </svg>
                Switch to Learning
              </>
            ) : mode === "learning" ? (
              <>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.54618 3.27793C7.71236 3.39789 7.98037 3.67345 7.98037 3.67345C9.02079 4.64858 10.5879 7.07394 11.0911 8.30444C11.1016 8.30444 11.4001 9.03608 11.4118 9.38409V9.43041C11.4118 9.96371 11.1133 10.4626 10.6335 10.7179C10.4357 10.8232 9.95456 10.9211 9.72244 10.9683C9.64556 10.984 9.59599 10.9941 9.59308 10.997C8.90727 11.1016 7.85514 11.1704 6.70003 11.1704C5.48757 11.1704 4.38981 11.1016 3.71453 10.9733C3.70282 10.9733 3.08606 10.8462 2.88009 10.7642C2.58282 10.6372 2.3312 10.4044 2.17087 10.1145C2.05618 9.88294 2 9.63827 2 9.38409C2.01053 9.11685 2.18257 8.618 2.26215 8.42083C2.76539 7.12026 4.41204 4.6367 5.41852 3.68532C5.52307 3.57922 5.64206 3.46806 5.72485 3.39071C5.76902 3.34945 5.8029 3.3178 5.81877 3.30169C6.07039 3.10452 6.37936 3 6.71173 3C7.00783 3 7.30509 3.09264 7.54618 3.27793ZM18.2286 10.1618C18.2286 10.6856 17.8108 11.1096 17.2947 11.1096C16.7786 11.1096 16.3608 10.6856 16.3608 10.1618L16.1033 5.58295C16.1033 4.91543 16.637 4.375 17.2947 4.375C17.9524 4.375 18.4849 4.91543 18.4849 5.58295L18.2286 10.1618ZM21.1199 13.2356C21.4172 13.3639 21.6688 13.5955 21.8291 13.8853C21.9438 14.1169 22 14.3616 22 14.617C21.9895 14.883 21.8174 15.3831 21.7367 15.5802C21.2346 16.8797 19.5868 19.3633 18.5815 20.3158C18.4787 20.4194 18.3619 20.5284 18.2793 20.6055H18.2792C18.2331 20.6486 18.1976 20.6817 18.1812 20.6983C17.9284 20.8955 17.6206 21 17.2894 21C16.991 21 16.6937 20.9074 16.4538 20.7209C16.2876 20.6021 16.0196 20.3265 16.0196 20.3265C14.978 19.3526 13.4121 16.926 12.9089 15.6954C12.8972 15.6954 12.5999 14.965 12.5882 14.617V14.5706C12.5882 14.0361 12.8855 13.5373 13.3665 13.2819C13.5639 13.1777 14.0435 13.0796 14.2762 13.0319C14.3539 13.016 14.404 13.0058 14.4069 13.0028C15.0927 12.8983 16.1449 12.8294 17.3 12.8294C18.5124 12.8294 19.6102 12.8983 20.2855 13.0265C20.296 13.0265 20.9139 13.1536 21.1199 13.2356ZM6.70553 12.8905C6.18942 12.8905 5.77161 13.3146 5.77161 13.8383L5.51414 18.4171C5.51414 19.0846 6.04781 19.625 6.70553 19.625C7.36325 19.625 7.89575 19.0846 7.89575 18.4171L7.63945 13.8383C7.63945 13.3146 7.22165 12.8905 6.70553 12.8905Z"
                    fill="black"
                  />
                </svg>
                Switch to Teaching
              </>
            ) : mode === "teaching" ? (
              <>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.54618 3.27793C7.71236 3.39789 7.98037 3.67345 7.98037 3.67345C9.02079 4.64858 10.5879 7.07394 11.0911 8.30444C11.1016 8.30444 11.4001 9.03608 11.4118 9.38409V9.43041C11.4118 9.96371 11.1133 10.4626 10.6335 10.7179C10.4357 10.8232 9.95456 10.9211 9.72244 10.9683C9.64556 10.984 9.59599 10.9941 9.59308 10.997C8.90727 11.1016 7.85514 11.1704 6.70003 11.1704C5.48757 11.1704 4.38981 11.1016 3.71453 10.9733C3.70282 10.9733 3.08606 10.8462 2.88009 10.7642C2.58282 10.6372 2.3312 10.4044 2.17087 10.1145C2.05618 9.88294 2 9.63827 2 9.38409C2.01053 9.11685 2.18257 8.618 2.26215 8.42083C2.76539 7.12026 4.41204 4.6367 5.41852 3.68532C5.52307 3.57922 5.64206 3.46806 5.72485 3.39071C5.76902 3.34945 5.8029 3.3178 5.81877 3.30169C6.07039 3.10452 6.37936 3 6.71173 3C7.00783 3 7.30509 3.09264 7.54618 3.27793ZM18.2286 10.1618C18.2286 10.6856 17.8108 11.1096 17.2947 11.1096C16.7786 11.1096 16.3608 10.6856 16.3608 10.1618L16.1033 5.58295C16.1033 4.91543 16.637 4.375 17.2947 4.375C17.9524 4.375 18.4849 4.91543 18.4849 5.58295L18.2286 10.1618ZM21.1199 13.2356C21.4172 13.3639 21.6688 13.5955 21.8291 13.8853C21.9438 14.1169 22 14.3616 22 14.617C21.9895 14.883 21.8174 15.3831 21.7367 15.5802C21.2346 16.8797 19.5868 19.3633 18.5815 20.3158C18.4787 20.4194 18.3619 20.5284 18.2793 20.6055H18.2792C18.2331 20.6486 18.1976 20.6817 18.1812 20.6983C17.9284 20.8955 17.6206 21 17.2894 21C16.991 21 16.6937 20.9074 16.4538 20.7209C16.2876 20.6021 16.0196 20.3265 16.0196 20.3265C14.978 19.3526 13.4121 16.926 12.9089 15.6954C12.8972 15.6954 12.5999 14.965 12.5882 14.617V14.5706C12.5882 14.0361 12.8855 13.5373 13.3665 13.2819C13.5639 13.1777 14.0435 13.0796 14.2762 13.0319C14.3539 13.016 14.404 13.0058 14.4069 13.0028C15.0927 12.8983 16.1449 12.8294 17.3 12.8294C18.5124 12.8294 19.6102 12.8983 20.2855 13.0265C20.296 13.0265 20.9139 13.1536 21.1199 13.2356ZM6.70553 12.8905C6.18942 12.8905 5.77161 13.3146 5.77161 13.8383L5.51414 18.4171C5.51414 19.0846 6.04781 19.625 6.70553 19.625C7.36325 19.625 7.89575 19.0846 7.89575 18.4171L7.63945 13.8383C7.63945 13.3146 7.22165 12.8905 6.70553 12.8905Z"
                    fill="black"
                  />
                </svg>
                Switch to Learning
              </>
            ) : (
              <>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.294 7.29105C17.294 10.2281 14.9391 12.5831 12 12.5831C9.0619 12.5831 6.70601 10.2281 6.70601 7.29105C6.70601 4.35402 9.0619 2 12 2C14.9391 2 17.294 4.35402 17.294 7.29105ZM12 22C7.66237 22 4 21.295 4 18.575C4 15.8539 7.68538 15.1739 12 15.1739C16.3386 15.1739 20 15.8789 20 18.599C20 21.32 16.3146 22 12 22Z"
                    fill="white"
                  />
                </svg>
                Become a Teacher
              </>
            )}
          </li>

          <li
            className="profileCard__dropdownMenuItem flex-row"
            onClick={() => history.push("/contact-support")}
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.4 1.5195C6.62 1.8295 3 6.0095 3 10.8095V20.4995H9V12.4995H5V10.7895C5 6.9495 7.96 3.6095 11.79 3.4995C15.76 3.3895 19 6.5595 19 10.4995V12.4995H15V20.4995H19V21.4995H12V23.4995H21V10.4995C21 5.3295 16.64 1.1795 11.4 1.5195Z"
                fill="#11BB70"
              />
            </svg>
            Contact Support
          </li>
          <li
            className="profileCard__dropdownMenuItem flex-row"
            onClick={showSetting}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.4345 4C26.9469 4 28.3164 4.84 29.0726 6.08C29.4405 6.68 29.6858 7.42 29.6245 8.2C29.5836 8.8 29.7676 9.4 30.0946 9.96C31.137 11.66 33.4466 12.3 35.2452 11.34C37.2687 10.18 39.8236 10.88 40.9886 12.86L42.3581 15.22C43.5435 17.2 42.8895 19.74 40.8456 20.88C39.1082 21.9 38.4951 24.16 39.5375 25.88C39.8645 26.42 40.2324 26.88 40.8047 27.16C41.5201 27.54 42.0719 28.14 42.4603 28.74C43.2165 29.98 43.1552 31.5 42.4194 32.84L40.9886 35.24C40.2324 36.52 38.8221 37.32 37.3709 37.32C36.6555 37.32 35.8584 37.12 35.2044 36.72C34.6729 36.38 34.0598 36.26 33.4057 36.26C31.3822 36.26 29.6858 37.92 29.6245 39.9C29.6245 42.2 27.7441 44 25.3936 44H22.6138C20.2429 44 18.3625 42.2 18.3625 39.9C18.3216 37.92 16.6252 36.26 14.6017 36.26C13.9272 36.26 13.314 36.38 12.8031 36.72C12.149 37.12 11.3314 37.32 10.6365 37.32C9.16489 37.32 7.75459 36.52 6.99834 35.24L5.58804 32.84C4.83179 31.54 4.79091 29.98 5.54716 28.74C5.87419 28.14 6.48736 27.54 7.18229 27.16C7.75459 26.88 8.12249 26.42 8.46996 25.88C9.49192 24.16 8.87874 21.9 7.14141 20.88C5.11794 19.74 4.46389 17.2 5.62892 15.22L6.99834 12.86C8.18381 10.88 10.7183 10.18 12.7622 11.34C14.5404 12.3 16.85 11.66 17.8924 9.96C18.2194 9.4 18.4034 8.8 18.3625 8.2C18.3216 7.42 18.5465 6.68 18.9348 6.08C19.6911 4.84 21.0605 4.04 22.5525 4H25.4345ZM24.0242 18.36C20.8152 18.36 18.2194 20.88 18.2194 24.02C18.2194 27.16 20.8152 29.66 24.0242 29.66C27.2331 29.66 29.7676 27.16 29.7676 24.02C29.7676 20.88 27.2331 18.36 24.0242 18.36Z"
                fill="white"
              />
            </svg>
            Settings
          </li>
          <li className="profileCard__dropdownMenuItem flex-row">
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.9855 4C27.9506 4 32 7.98 32 12.88V22.46H19.7907C18.9157 22.46 18.2238 23.14 18.2238 24C18.2238 24.84 18.9157 25.54 19.7907 25.54H32V35.1C32 40 27.9506 44 22.9448 44H13.0349C8.04942 44 4 40.02 4 35.12V12.9C4 7.98 8.06977 4 13.0552 4H22.9855ZM37.0804 17.1004C37.6804 16.4804 38.6604 16.4804 39.2604 17.0804L45.1004 22.9004C45.4004 23.2004 45.5604 23.5804 45.5604 24.0004C45.5604 24.4004 45.4004 24.8004 45.1004 25.0804L39.2604 30.9004C38.9604 31.2004 38.5604 31.3604 38.1804 31.3604C37.7804 31.3604 37.3804 31.2004 37.0804 30.9004C36.4804 30.3004 36.4804 29.3204 37.0804 28.7204L40.2804 25.5404H32.0004V22.4604H40.2804L37.0804 19.2804C36.4804 18.6804 36.4804 17.7004 37.0804 17.1004Z"
                fill="white"
              />
            </svg>
            Logout
          </li>
          <li className="profileCard__dropdownMenuItem flex-row toggle">
            <div className="profileCard__dropdownToggle">
              <input
                type="checkbox"
                checked={darkMode}
                onChange={() => setDarkMode((darkMode) => !darkMode)}
              />
              <div
                className="profileCard__dropdownToggleIcon item-center rounded"
                onClick={() => setDarkMode((darkMode) => !darkMode)}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 29 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="4.24707"
                    y="4.45752"
                    width="20.5061"
                    height="20.5061"
                    fill="white"
                  />
                  <rect
                    y="14.7104"
                    width="20.5061"
                    height="20.5061"
                    transform="rotate(-45 0 14.7104)"
                    fill="white"
                  />
                  <circle cx="14.3973" cy="14.8128" r="8.09991" fill="black" />
                  <circle cx="14.3973" cy="14.8129" r="6.86954" fill="white" />
                </svg>
              </div>
            </div>
          </li>
        </ul>
      </div>
      {isSettingOpen && <SettingPopup onClick={showSetting} />}
    </>
  );
};

export default ProfilePage;
